import { EntityDefinition } from '@/types/crud';

export const riskRegisterEntity: EntityDefinition = {
  name: 'riskRegisters',
  displayName: 'Risk Registers',
  displayNameSingular: 'Risk Register',
  apiEndpoint: '/generic/risk_registers',
  idField: 'id',
  nameField: 'name',
  copyable: true,
  deletable: true,
  searchable: true,
  sortable: true,
  pageSize: 20,
  fields: [
    {
      key: 'id',
      label: 'ID',
      type: 'text',
      hidden: true,
      order: 0
    },
    {
      key: 'name',
      label: 'Register Name',
      type: 'text',
      required: true,
      placeholder: 'Enter register name',
      order: 1
    },
    {
      key: 'description',
      label: 'Description',
      type: 'textarea',
      placeholder: 'Enter register description',
      order: 2
    },
    {
      key: 'status',
      label: 'Status',
      type: 'select',
      options: [
        { value: 'ACTIVE', label: 'Active' },
        { value: 'INACTIVE', label: 'Inactive' },
        { value: 'SUSPENDED', label: 'Suspended' }
      ],
      defaultValue: 'ACTIVE',
      order: 3
    },
    {
      key: 'owner_id',
      label: 'Owner ID',
      type: 'text',
      hidden: true,
      order: 4
    },
    {
      key: 'created_at',
      label: 'Created',
      type: 'datetime',
      hidden: true,
      order: 5
    },
    {
      key: 'updated_at',
      label: 'Updated',
      type: 'datetime',
      hidden: true,
      order: 6
    },
    {
      key: 'tenant_id',
      label: 'Tenant ID',
      type: 'text',
      hidden: true,
      order: 7
    }
  ],
  tableColumns: [
    {
      key: 'name',
      label: 'Register Name',
      sortable: true
    },
    {
      key: 'description',
      label: 'Description',
      sortable: true
    },
    {
      key: 'status',
      label: 'Status',
      sortable: true
    },
    {
      key: 'created_at',
      label: 'Created',
      sortable: true
    }
  ],
  searchFields: ['name', 'description'],
  defaultSort: { field: 'name', direction: 'asc' }
};